import { useState } from "react";
import LoginLayout from "../layouts/LoginLayout";
import { useAuthContext } from "../providers/AuthProvider";
import { OtpInput } from "reactjs-otp-input";
import { UserType } from "../helpers/types";
import Button from "../components/Button";
import { useTranslation } from "react-i18next";

const EmailVerification = () => {
    const { t } = useTranslation();
    const { user, setUserData, apiCall } = useAuthContext();
    const [otp, setOtp] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (otp: string) => {
        setOtp(otp);
        if (otp.length === 4) {
            // Check validation
            checkVerificationCode(otp);
        }
    };

    const handleBack = async () => {
        await apiCall({
            action: 'removeBankId',
            user: user
        });

        if (user) {
            setUserData({
                ...user,
                bankid: undefined,
            });
        }
    }

    const checkVerificationCode = async (value?: string) => {
        setLoading(true);
        try {
            const response = await apiCall({
                action: 'checkVerificationCode',
                code: value ? value : otp,
                sub: user?.bankid
            });

            if (response?.data?.status === 200) {
                setUserData({
                    ...user,
                    verified_email: true,
                } as UserType);
            } else {

            }
        } finally {
            setLoading(false);
        }
    }

    return (
        <LoginLayout
            title="Ett siste steg"
            subtitle={`Vi har sendt en kode til <b>${user?.email}</b>. Fyll inn koden under. Dette må du bare gjøre én gang!`}
            helperText={
                <div className="textcenter">
                    <p className="mt-4">Hvis du ikke mottar en kode, sjekk at e-postadressen du har oppgitt over er korrekt. Hvis den er det kan du sjekke søppelpost.</p>
                    <a href="#" className="text-decoration-none" onClick={handleBack}>Tilbake</a>
                </div>
            }
            display="col-lg-8"
        >
            <div className="row justify-content-center">
                <div className="col-auto text-center">
                    <OtpInput
                        value={otp}
                        onChange={handleChange}
                        numInputs={4}
                        containerStyle={{
                            display: 'flex',
                            gap: 10
                        }}
                        inputStyle={{
                            width: 45,
                            height: 48,
                            borderRadius: '6px',
                            border: '1px solid #DEE2E6'
                        }}
                    />

                    <Button
                        title={t('verify')}
                        onClick={() => checkVerificationCode()}
                        disabled={otp.length != 4 || loading}
                        classes="mt-4"
                    />
                </div>
            </div>

        </LoginLayout>
    )
}

export default EmailVerification;